import { useEffect, useRef, useState } from 'react';
import useScrollThrottle from './useScrollThrottle';

const usePageScroll = (settings) => {
    const [isTop, setIsTop] = useState(true);
    const [isInOffset, setIsInOffset] = useState(true);
    const [leftOffsetFromTop, setLeftOffsetFromTop] = useState(false);

    const lastScrollPos = useRef(0);
    const pxSinceLastSwitch = useRef(0);

    const [scrollDirection, setScrollDirection] = useState('DOWN');

    const directionDownOffset =
        settings && settings.directionOffset
            ? settings.directionOffset.down || 0
            : 0;
    const directionUpOffset =
        settings && settings.directionOffset
            ? settings.directionOffset.up || 0
            : 0;

    // Throttle scroll event for perfomance
    const scrollState = useScrollThrottle(
        settings && settings.resizeThrottleTimeout !== undefined
            ? settings.resizeThrottleTimeout
            : 0
    );

    useEffect(() => {
        if (!scrollState) return;
        if (typeof window === 'undefined') return;

        const scrollY = scrollState.scrollY;
        const isTop = scrollY <= 0;

        // check if page is scroll on top
        setIsTop(isTop);

        // check offset
        if (settings && settings.offset && scrollY <= settings.offset) {
            setIsInOffset(true);
        } else {
            setIsInOffset((prev) => {
                if (prev) {
                    settings.onLeftOffset &&
                        settings.onLeftOffset(scrollDirection);
                    setLeftOffsetFromTop(true);
                }
                return false;
            });
        }

        /**
         * calculate direction changes
         */

        // get difference between current and last scrollY position
        const diff = scrollY - lastScrollPos.current;
        // get accumulated pixels since last direction change
        let absAccPx = Math.abs(pxSinceLastSwitch.current);

        // check if direction changed. if not iterate accumulated pixels value
        if (diff < 0 && pxSinceLastSwitch.current > 0) {
            pxSinceLastSwitch.current = 0;
        } else if (diff > 0 && pxSinceLastSwitch.current < 0) {
            pxSinceLastSwitch.current = 0;
        } else {
            pxSinceLastSwitch.current += diff;
        }

        // set current accumulated value
        absAccPx = Math.abs(pxSinceLastSwitch.current);

        // set direction states
        if (isTop) {
            setScrollDirection('DOWN');
        } else if (diff < 0 && absAccPx >= directionUpOffset) {
            setScrollDirection('UP');
        } else if (diff > 0 && absAccPx >= directionDownOffset) {
            setScrollDirection('DOWN');
        }

        // save last scroll position
        lastScrollPos.current = scrollY;
    }, [
        directionDownOffset,
        directionUpOffset,
        scrollDirection,
        scrollState,
        settings,
    ]);

    useEffect(() => {
        // reset left offset flag on top
        if (isTop) setLeftOffsetFromTop(false);
    }, [isTop]);

    return {
        isTop,
        scrollDirection,
        isInOffset,
        leftOffsetFromTop,
    };
};

export default usePageScroll;



// WEBPACK FOOTER //
// ./src/utils/usePageScroll.js